import React, { useState } from 'react';
import { Row, useAsyncDebounce } from 'react-table';

interface GlobalFilterProps<T extends object> {
    preGlobalFilteredRows: Row<T>[];
    globalFilter: string | number | readonly string[] | undefined;
    setGlobalFilter: Function;
}

const GlobalFilter = <T extends object>({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
}: GlobalFilterProps<T>) => {
    const count = preGlobalFilteredRows.length;
    const [filterValue, setFilterValue] = useState(globalFilter);

    const onChange = useAsyncDebounce((value) => {
        setGlobalFilter(value || undefined);
    }, 300);

    return (
        <span>
            <i className="fas fa-search ml-2 mr-2" />

            <input
                value={filterValue || ''}
                className="width-300"
                onChange={(e) => {
                    setFilterValue(e.target.value);
                    onChange(e.target.value || undefined);
                }}
                placeholder={`Type to filter ${count} records`}
            />
        </span>
    );
};
export default GlobalFilter;
